<template>
    <div v-loading="loading">
        <div class="mb10">
            <span>预计合同总金额: <span v-if="contract.estmtAmount != null">{{contract.estmtAmount.toFixed(2)}}&nbsp;元</span></span>
            <span v-if="contractType != servcPurch.value" class="ml20">预计合同商品数量: <span>{{contract.estmtGoodsCount}}</span></span>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th class="align-left"><span class="pl5">阶段名称</span></th>
                <th width="100">预计金额(元)</th>
                <th width="100">实际金额(元)</th>
                <th width="100">预计金额(%)</th>
                <th width="100">实际金额(%)</th>
                <th v-if="contractType != servcPurch.value" width="80">预计数量</th>
                <th v-if="contractType != servcPurch.value" width="80">实际数量</th>
                <th v-if="contractType != servcPurch.value" width="90">预计数量(%)</th>
                <th v-if="contractType != servcPurch.value" width="90">实际数量(%)</th>
                <th width="100">付款账期(天)</th>
                <th width="100">账期开始</th>
                <th width="100">账期结束</th>
                <th width="100">质保开始日</th>
                <th width="80">当前阶段</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="(trackPhase, index) in contractTrackPhaseList">
                <td class="align-left"><span class="pl5">{{trackPhase.name}}</span></td>
                <td>{{trackPhase.amountPay.toFixed(2)}}</td>
                <td class="font-green">
                    <span v-if="trackPhase.reatilyAmount != null">{{trackPhase.reatilyAmount.toFixed(2)}}</span>
                    <span v-else>0.00</span>
                </td>
                <td>{{trackPhase.amountPayPct.toFixed(2)}}</td>
                <td class="font-green">
                    <span v-if="trackPhase.estmtAmount != null && trackPhase.estmtAmount != 0">{{((trackPhase.reatilyAmount / trackPhase.estmtAmount) * 100).toFixed(2)}}</span>
                    <span v-else>0.00&nbsp;%</span>
                </td>
                <td v-if="contractType != servcPurch.value">{{trackPhase.goodsDeliverCount}}</td>
                <td class="font-green" v-if="contractType != servcPurch.value">{{trackPhase.reatilyQuantity}}</td>
                <td v-if="contractType != servcPurch.value">
                    <span v-if="trackPhase.goodsDeliverCountPct != null">{{trackPhase.goodsDeliverCountPct.toFixed(2)}}</span>
                    <span v-else>0.00</span>
                </td>
                <td class="font-green" v-if="contractType != servcPurch.value">
                    <span v-if="trackPhase.estmtGoodsCount != null && trackPhase.estmtGoodsCount != 0">{{((trackPhase.reatilyQuantity / trackPhase.estmtGoodsCount) * 100).toFixed(2)}}</span>
                    <span v-else>0.00&nbsp;%</span>
                </td>
                <td>{{trackPhase.payDays}}</td>
                <td>{{trackPhase.payStartTime == null ? null : formatDate(trackPhase.payStartTime)}}</td>
                <td>{{trackPhase.payDueTime == null ? null : formatDate(trackPhase.payDueTime)}}</td>
                <td>{{trackPhase.wrntPeriodStartTime == null ? null : formatDate(trackPhase.wrntPeriodStartTime)}}</td>
                <td>
                    <span class="font-green" v-if="trackPhase.wrntPeriodStarted">质保已起算</span>
                    <span class="font-green" v-if="!trackPhase.wrntPeriodStarted && trackPhase.deliverFinished">交付完成</span>
                    <span v-if="trackPhase.active">是</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import contractApi from '../../api/contract'

    export default {
        name: 'swb-contract-data-monitoring',
        desc: '合同数据监控',
        props: ['contractId', 'contractNo', 'contractType'],
        data: function () {
            return {
                contract: {},
                contractTrackPhaseList: [],
                loading: false,
                goodsPurch: {},
                servcPurch: {},
                integPurch: {}
            }
        },
        created: function () {

            this.goodsPurch = getEnumInfoWith("contractType", 'name', 'GoodsPurch');
            this.servcPurch = getEnumInfoWith("contractType", 'name', 'ServcPurch');
            this.integPurch = getEnumInfoWith("contractType", 'name', 'IntegPurch');

            this.getContractDataMonitoringDtoList(this.contractId);
            this.getContractByNo(this.contractNo);
        },
        methods: {
            formatDate: function (date) {
                let newDate = new Date(date);
                let forDate = newDate.format("yyyy-MM-dd");
                return forDate;
            },
            getContractDataMonitoringDtoList: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                contractApi.getContractMonitorDataList(postData, function (result) {
                    if(result.type == "info") {
                        self.contractTrackPhaseList = result.data;
                    }
                });
            },
            getContractByNo: function (contractNo) {
                let self = this;
                let postData = {};
                postData.no = contractNo;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        self.contract = result.data;
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractDataMonitoring.vue